import Castrolelevate from "../../assets/svg/Castrolelevate";
import "./Downtimestyles.css";

const DowntimePage = () => {
  return (
    <div className="downtime-page">
      {/* decorative background blobs */}
      <div className="downtime-blob downtime-blob--one" />
      <div className="downtime-blob downtime-blob--two" />
      <div className="downtime-blob downtime-blob--three" />

      <div className="downtime-wrapper">
        {/* ── Left: copy ── */}
        <div className="downtime-left">
          <Castrolelevate className="global-castrol-icon" />

          <span className="downtime-eyebrow">Scheduled Maintenance</span>

          <h1 className="downtime-title">
            Castrol Elevate is <span>Under Maintenance</span>
          </h1>

          <div className="downtime-status-card">
            <div className="downtime-status-row">
              <span className="downtime-status-dot" />
              <span className="downtime-status-label">
                Status: <strong>In progress</strong>
              </span>
            </div>
          </div>

          <div className="downtime-schedule-card">
            <div className="downtime-schedule-title">
              <i className="pi pi-clock" />
              Operational Hours
            </div>
            <div className="downtime-schedule-row">
              <span className="downtime-schedule-day">Monday – Saturday</span>
              <span className="downtime-schedule-time">
                8:30 AM – 11:30 PM 
              </span>
            </div>
            <div className="downtime-schedule-row">
              <span className="downtime-schedule-day">Sunday</span>
              <span className="downtime-schedule-time">
                8:30 AM – 4:30 PM 
              </span>
            </div>
          </div>
        </div>

        {/* ── Right: illustration ── */}
        <div className="downtime-right">
          <svg
            viewBox="0 0 400 400"
            className="downtime-illustration"
            xmlns="http://www.w3.org/2000/svg"
          >
            {/* soft backdrop circle */}
            <circle cx="200" cy="200" r="170" fill="#F3F0FB" />
            <circle
              cx="200"
              cy="200"
              r="170"
              fill="none"
              stroke="#E4DEF8"
              strokeWidth="2"
              strokeDasharray="4 10"
            />

            {/* browser card */}
            <rect
              x="70"
              y="96"
              width="260"
              height="188"
              rx="18"
              fill="#FFFFFF"
              stroke="#E5E7EB"
              strokeWidth="2"
            />
            <rect
              x="70"
              y="96"
              width="260"
              height="34"
              rx="18"
              fill="#1F2937"
            />
            <rect x="70" y="112" width="260" height="18" fill="#1F2937" />
            <circle cx="90" cy="113" r="5" fill="#EF4444" />
            <circle cx="106" cy="113" r="5" fill="#F59E0B" />
            <circle cx="122" cy="113" r="5" fill="#22C55E" />

            {/* content skeleton lines inside browser */}
            <rect
              x="92"
              y="150"
              width="120"
              height="10"
              rx="5"
              fill="#E5E7EB"
            />
            <rect
              x="92"
              y="170"
              width="180"
              height="10"
              rx="5"
              fill="#EFF1F4"
            />
            <rect
              x="92"
              y="190"
              width="150"
              height="10"
              rx="5"
              fill="#EFF1F4"
            />
            <rect
              x="92"
              y="222"
              width="216"
              height="34"
              rx="10"
              fill="#F3F0FB"
            />

            {/* gear */}
            <g transform="translate(150,150)">
              {[0, 45, 90, 135, 180, 225, 270, 315].map((angle) => (
                <rect
                  key={angle}
                  x="-7"
                  y="-52"
                  width="14"
                  height="20"
                  rx="4"
                  fill="#1F7A3D"
                  transform={`rotate(${angle})`}
                />
              ))}
              <circle r="42" fill="#1F7A3D" />
              <circle r="30" fill="#2E9E52" />
              <circle r="12" fill="#FFFFFF" />
            </g>

            {/* wrench */}
            <g transform="translate(215,150) rotate(45)">
              <rect
                x="-10"
                y="-46"
                width="20"
                height="92"
                rx="10"
                fill="#E2231A"
              />
              <circle cx="0" cy="-46" r="16" fill="#E2231A" />
              <circle cx="0" cy="-46" r="7" fill="#FFFFFF" />
              <circle cx="0" cy="46" r="12" fill="#B71C13" />
            </g>

            {/* floating clock badge */}
            <g transform="translate(292,268)">
              <circle r="38" fill="#FFFFFF" stroke="#E5E7EB" strokeWidth="2" />
              <circle r="27" fill="#F3F0FB" />
              <line
                x1="0"
                y1="0"
                x2="0"
                y2="-16"
                stroke="#6A5FC1"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <line
                x1="0"
                y1="0"
                x2="11"
                y2="6"
                stroke="#6A5FC1"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <circle r="3.5" fill="#6A5FC1" />
            </g>

            {/* scattered dots */}
            <circle cx="60" cy="80" r="6" fill="#2E9E52" opacity="0.5" />
            <circle cx="340" cy="120" r="5" fill="#E2231A" opacity="0.4" />
            <circle cx="330" cy="330" r="7" fill="#6A5FC1" opacity="0.35" />
            <circle cx="55" cy="320" r="5" fill="#6A5FC1" opacity="0.3" />
          </svg>
        </div>
      </div>

      <div className="col-12 footerImage">
        <img
          src={require("../../assets/images/nriseLogo.png")}
          alt="nRise Logo"
        />
      </div>
    </div>
  );
};

export default DowntimePage;
